// ABOUTME: Header component for tooltip with title, subtitle, and optional icon
// ABOUTME: Provides consistent styling for tooltip headers

import { memo, type ReactNode } from "react"
import { TooltipDivider } from "./TooltipDivider"

interface TooltipHeaderProps {
  title: string
  subtitle?: string
  icon?: ReactNode
  iconBgColor?: string
  showDivider?: boolean
  className?: string
}

export const TooltipHeader = memo(
  ({ title, subtitle, icon, iconBgColor, showDivider = true, className = "" }: TooltipHeaderProps) => {
    return (
      <>
        <div className={`flex items-center gap-2 ${className}`}>
          {icon && (
            <span className={`flex items-center justify-center w-5 h-5 rounded flex-shrink-0 ${iconBgColor || ""}`}>
              {icon}
            </span>
          )}
          <div className="flex-1 min-w-0">
            <div className="font-semibold text-[13px] leading-tight truncate">{title}</div>
            {subtitle && <div className="text-[11px] text-gray-400 truncate">{subtitle}</div>}
          </div>
        </div>
        {showDivider && <TooltipDivider />}
      </>
    )
  },
)

TooltipHeader.displayName = "TooltipHeader"
